import algoliasearch, { type SearchClient } from 'algoliasearch';
import { getAlgoliaApiId, getAlgoliaReadApiKey } from '../../helpers/env';

let searchClient: SearchClient | undefined;

const algoliaClient = () => {
  if (!searchClient) {
    searchClient = algoliasearch(
      getAlgoliaApiId(),
      getAlgoliaReadApiKey(),
    );
  }

  return searchClient;
};

export default algoliaClient;
